import moment from "moment";
import React, { useMemo } from "react";
import { titleWithoutUnderscore } from "../../helpers/utility";
import VezoCallBtn from "../vezoCallBtn";

export const ApptMessage = ({msg, isLoggedInUser}) => {

    return (
        <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-white border'}  p-2 shadow`}>
            <div className={`text-gray-800 text-start`}>
                <h1 className={`flex gap-2 justify-between capitalize font-bold border-b }  py-1 px-2 rounded-t-md`}>
                    {titleWithoutUnderscore(msg.message?.event_type)}
                </h1>
                <div className={`p-2 rounded-b-md`}>
                    <p>On: {moment(msg.message.data?.start_time).format('MM/DD/YYYY hh:mm A')}</p>
                    <p>With: {msg.message.data?.provider_name}</p>
                    <VezoCallBtn item={msg.message.data} />
                </div>
            </div>
        </div>
    );
};